export default __webpack_public_path__ + "static/media/logo_conservatorio.3679ee51.png";